import { render, staticRenderFns } from "./user_map.vue?vue&type=template&id=54ac867e&"
import script from "./user_map.vue?vue&type=script&lang=ts&"
export * from "./user_map.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports